import { SERVER_ROUTES } from "../../enums/Enums";
import * as axiosActions from "../../managers/Axios/AxiosActions";
import { trackException } from "../Azure/ApplicationInsightsActions";
export const updateUserScopeRole = (userScope) => {
  return new Promise((resolve, reject) => {
    var requestBody = userScope;

    axiosActions
      .PUT(SERVER_ROUTES.UPDATE_USER_SCOPE, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - updateUserScopeRole()",
          error
        );
        reject(error);
      });
  });
};
export const addUserScopeRole = (userScope) => {
  return new Promise((resolve, reject) => {
    var requestBody = userScope;

    axiosActions
      .POST(SERVER_ROUTES.ADD_USER_SCOPE, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - addUserScopeRole()",
          error
        );
        reject(error);
      });
  });
};

export const deleteUserScopeRole = (userScopeId) => {
    return new Promise((resolve, reject) => {

      axiosActions
        .DELETE(SERVER_ROUTES.DElETE_USER_SCOPE + userScopeId)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException(
            "ActionsService.js - deleteUserScopeRole()",
            error
          );
          reject(error);
        });
    });
  };
  export const inactiveUserScopeRoleList = (userScopeIdsList) => {
    return new Promise((resolve, reject) => {
      var requestBody = userScopeIdsList;
  
      axiosActions
        .PUT(SERVER_ROUTES.INACTIVE_USER_SCOPE_LIST, requestBody)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException(
            "ActionsService.js - inactiveUserScopeRoleList()",
            error
          );
          reject(error);
        });
    });
  };